import { IUrlFilter, IFilter } from 'api/types/filter'

class FilterService {
  getSelectedFilters = ({
    urlFilters,
    filter,
  }: {
    urlFilters: Array<IUrlFilter>
    filter: IFilter
  }) => urlFilters.filter((item) => item.category === filter.id)
  isSelectedFilter = ({
    urlFilters,
    filter,
  }: {
    urlFilters: Array<IUrlFilter>
    filter: IUrlFilter
  }) => urlFilters.some((item) => item.id === filter.id)
}

export const filterService = new FilterService()
